"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg24VehicleCar = function Svg24VehicleCar(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 11c0-.254-.049-.507-.143-.743L19.662 7.27l-.061-.154c-.22-.558-.498-1.258-.995-1.805a4 4 0 0 0-1.562-1.058C16.352 3.994 15.6 3.997 15 4H9.001c-.6-.003-1.353-.006-2.045.252A4 4 0 0 0 5.394 5.31c-.497.547-.774 1.247-.995 1.805l-.06.154-1.196 2.988A2 2 0 0 0 3 11v7.5c0 .466 0 .699.076.883a1 1 0 0 0 .541.54c.184.077.417.077.883.077s.699 0 .883-.076a1 1 0 0 0 .54-.541C6 19.199 6 18.966 6 18.5V18h12v.5c0 .466 0 .699.076.883a1 1 0 0 0 .541.54c.184.077.417.077.883.077s.699 0 .883-.076a1 1 0 0 0 .54-.541c.077-.184.077-.417.077-.883V11zm-3.874-4.345c.243.267.388.63.679 1.357L18.6 10H5.4l.795-1.988c.29-.727.436-1.09.679-1.357a2 2 0 0 1 .781-.529C7.993 6 8.385 6 9.166 6h5.668c.782 0 1.173 0 1.511.126a2 2 0 0 1 .781.529zM19 13.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM6.5 15a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg24VehicleCar.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg24VehicleCar;
exports.default = _default;